const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.885,
    height: 19.915,
    viewBox: "0 0 19.885 19.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4320",
    d: "M169.481 112c-2.075 0-3.313 1.3-3.313 3.474 0 1.238 1.642 4.1 3.313 6.382 1.66-2.291 3.314-5.116 3.314-6.382 0-2.174-1.239-3.474-3.314-3.474zm0 4.963a1.458 1.458 0 1 1 1.455-1.458 1.456 1.456 0 0 1-1.458 1.458z",
    transform: "translate(-159.539 -107.362)",
    style: {
      fill: "#f6b119"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4321",
    d: "M9.442 0a9.458 9.458 0 1 0 9.442 9.458A9.45 9.45 0 0 0 9.442 0zM10 15.233l-.553.727-.55-.727c-.4-.53-3.944-5.263-3.944-7.62a4.289 4.289 0 0 1 4.489-4.658 4.289 4.289 0 0 1 4.494 4.657c0 2.354-3.536 7.088-3.936 7.621z",
    style: {
      fill: "#fff",
      stroke: "#ececec"
    },
    transform: "translate(.5 .5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.36d8285578320208aeeaf9d2639bcbfb.svg";
export { ForwardRef as ReactComponent };